import $http from '$http'
import {
    cloneDeep,
    util,
    isCorrectVal,
    isDate,
    lg
} from 'utils';

export default {
    methods: {

        // GET /api/NewAgent/GetById
        GetById(Id) {
            var Params = {
                Sid: this.sysSid,
                Session: this.sysSession,
                Id: Id
            };

            $http.get('api/NewAgent/GetById', Params).then(res => {
                let {
                    Data
                } = res.data;
                util.doResult(this, res, () => {
                    this.form = Data
                    this.examineData.TimeStamp = Data.TimeStamp
                    this.baseInfo = cloneDeep(this.form.Customer);
                    this.contact = cloneDeep(this.form.Contact);
                    this.agentList = this.form.List
                    this.Corporation_Drawing = this.baseInfo.Corporation_Drawing
                    this.Company_Drawing = this.baseInfo.Company_Drawing
                });
            });
        },
        // 区域查看获取单条
        GetByCustomerAreaId(Id, AgentAreaId) {
            var Params = {
                Sid: this.sysSid,
                Session: this.sysSession,
                Id: Id,
                AgentAreaId: AgentAreaId
            };
            this.loading = true
            $http.get('api/NewAgent/GetById', Params).then(res => {
                let {
                    Data
                } = res.data;
                this.loading = false
                util.doResult(this, res, () => {
                    // this.form = Data
                    this.baseInfo = cloneDeep(Data.Customer);
                    this.contact = cloneDeep(Data.Contact);
                    this.form.Industry_Name = Data.Industry_Name
                    this.agentList = Data.List
                    if (this.contact.IsUpdateContactOrCustomer == 1) {
                        this.isShowContact = true
                    } else {
                        this.isShowContact = false
                    }
                    this.form.LogList = cloneDeep(Data.LogList)

                });
            });
        },
        // 审核POST /api/NewAgent/AgentAudit
        AgentAudit(data) {
            $http.post('api/NewAgent/AgentAudit', data).then(res => {
                util.doResult(this, res, () => {
                    this.$notify({
                        title: '成功',
                        message: '审核成功！',
                        type: 'success'
                    });
                    //重新获取幼儿园管理中的代理商管理
                    //this.$store.dispatch("getAgentList");
                    this.$emit('reload-list');
                    this.close();
                });
            });
        },
        // 区域审核POST /api/AgentAreas/AgentAreaAudit
        AgentAreaAudit(data) {
            $http.post('api/AgentAreas/AgentAreaAudit', data).then(res => {
                util.doResult(this, res, () => {
                    this.$notify({
                        title: '成功',
                        message: '区域审核成功！',
                        type: 'success'
                    });
                    //重新获取幼儿园管理中的代理商管理
                    //this.$store.dispatch("getAgentList");
                    this.$emit('reload-list');
                    this.close();
                });
            });
        },

    }
};


// WEBPACK FOOTER //
// ./src/pages/CRMAgentManage/components/viewDialog/services.js